import { Tabs, TabsProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DEFAULT_PAGE_SIZE, TEXT_BUTTON_HEADER_LIST } from "../../../config/config";
import { PermissionCustomer } from "../../../permissions/PermissionCustomer";
import customerStore from "../../../stores/customerStore";
import BreadCrumbComponent from "../../atoms/BreadCrumbComponent";
import NotPermissionComponent from "../../atoms/NotPermissionComponent";
import ContentBox from "../../molecules/ContentBox";
import LoadingComponent from "../../molecules/LoadingComponent";
import Permission from "../../molecules/Permission";
import { useAuth } from "../../protected/ProviderAuth";
import FormCustomer from "./FormCustomer";
import ListAddress from "./ListAddress";
import { PermissionAdministrator } from "../../../permissions/PermissionAdministrator";
import administratorStore from "../../../stores/administratorStore";

interface DataType {
  zipCode: string;
  street: string;
  block: string;
  number: string;
  state: string;
  city: string;
  key: React.Key;
}

const breadCrumb = [
  {
    title: <Link to="/dashboard">Dashboard</Link>,
  },
  {
    title: <Link to="/cliente">Listagem de Cliente</Link>,
  },
  {
    title: <p>Cadastro de Cliente</p>,
  },
];

const CreateCustomer: React.FC = observer(() => {
  const { uuid } = useParams<{ uuid: string }>();
  const { loading, } = customerStore;
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  const defaultparams = {
    size: 99999,
    page: 0,
    sort: 'created,desc',
    search: '',
  }

  useEffect(() => {
    const fetchPerfilData = async () => {
      if (uuid && hasPermission(PermissionCustomer.GET_UUID)) {
        await customerStore.getCustomerByUuid(uuid);
      }

      if (hasPermission(PermissionAdministrator.GET)) {
        await administratorStore.getList(defaultparams);
      }
    };
    fetchPerfilData();
    return () => {
      customerStore.reset();
    };
  }, []);

  const listRouter = () => {
    navigate(`/cliente`);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Informações Customer',
      children: <FormCustomer />,
    },
    {
      key: '2',
      label: 'Informação Endereço',
      children: <ListAddress />,
    },
  ];

  return (
    <>
      <BreadCrumbComponent
        breadCrumbList={breadCrumb}
        textButton={TEXT_BUTTON_HEADER_LIST}
        onClick={() => listRouter()}
        permission={PermissionCustomer.GET}
      />

      {loading && (
        <ContentBox
          className="mb-4 p-6"
          title="Cadastro de Clientes"
          description="Tela para cadastro de Clientes"
        >
          <LoadingComponent />
        </ContentBox>
      )}


      {!loading &&
        <Permission
          permissionKeys={[PermissionCustomer.PUT]}
          fallback={NotPermissionComponent()}
        >
          <Tabs className="mb-0" type="card" defaultActiveKey="1" items={items} />
        </Permission>
      }
    </>
  );
});

export default CreateCustomer;
